Namespace 'Common.Dashboard.Filters'

Common.Dashboard.Filters.UsersGroupFilterMixin =
  _getSelectedValues: ->
    noGroup = _.contains(
      @groupSelectorView.getSelectedValues(),
      CustomerVisualMode.Filters.SingleFilters.UsersGroupFilterView.NO_GROUP_VALUE
    )
    ids: _.without(
      @groupSelectorView.getSelectedValues(),
      CustomerVisualMode.Filters.SingleFilters.UsersGroupFilterView.NO_GROUP_VALUE
    )
    no_group: noGroup

  _displayTitle: ->
    I18n.t 'customer_visual_mode.filters.users_group'

  openUsersGroupFilterModal: ->
    @groupSelectorView?.remove()
    @groupSelectorView = new CustomerVisualMode.Filters.SingleFilters.UsersGroupFilterView(
      filter: @filter
      teams: @teams
      selectedOptions: @filter.getValues()
      title: @modalTitle()
      subtitle: @modalSubtitle()
    ).render()
    @listenTo(@groupSelectorView, 'filters:multiplevalues:apply', @applyFilter)
